export * from './date';
export * from './ordering';
export * from './user';
export * from './localStorage';
export * from './project';
export * from './file';
export * from './organization';
export * from './device';
export * from './devicePng/devicePng';
export * from './version';
export * from './app';
export * from './apollo';
export * from './theme';
export * from './userGroup';
export * from './location';
export * from './task';
export * from './equipment';
export * from './equipmentPng/equipmentPng';
export * from './issue';
export * from './language';
export * from './settings';
export * from './partners';

export const getKeyItem = (object: any, key: string) => {
    if (key in object) {
        return object[key];
    } else if (key && key.length) {
        var res = key.split('.');
        if (res && res.length > 0) {
            if (res[0] in object) {
                if (res.length > 1) {
                    if (object[res[0]] && res[1] in object[res[0]]) {
                        if (res.length > 2) {
                            if (object[res[0]][res[1]] && res[2] in object[res[0]][res[1]]) {
                                return object[res[0]][res[1]][res[2]];
                            }
                        } else {
                            return object[res[0]][res[1]];
                        }
                    }
                } else {
                    return object[res[0]];
                }
            }
        }
    }

    return '';
};

export const setKeyItem = (object: any, key: string, value: any): any => {
    if (key in object) {
        object[key] = value;
    } else if (key && key.length) {
        var res = key.split('.');
        if (res && res.length > 0) {
            if (res[0] in object) {
                if (res.length > 1) {
                    if (object[res[0]] && res[1] in object[res[0]]) {
                        if (res.length > 2) {
                            if (object[res[0]][res[1]] && res[2] in object[res[0]][res[1]]) {
                                object[res[0]][res[1]][res[2]] = value;
                            }
                        } else {
                            object[res[0]][res[1]] = value;
                        }
                    } else {
                        object[res[0]][res[1]] = value;
                    }
                } else {
                    object[res[0]] = value;
                }
            }
        }
    }
    return object;
};
